import { createSelector } from 'reselect';
import { compile } from 'path-to-regexp';

import { checkUsEnglish } from 'utils/checkUsEnglish';
import {
  editionPathTypeOrder,
  HOME,
} from 'config/types/path';
import {
  getLanguageCodeFromPath,
  getLinkParts,
  isAbsolute,
  isBabbelHostname,
  prependEditionHostname,
  hostIsStaging,
} from 'utils/url';

import getPathMap from './getPathMap';
import getFirstMatch from './getFirstMatch';
import { getEditionFromLocale } from './getEdition';
import getMatch from './getMatch';

const createGetEditionPath = (link) => createSelector(
  [
    getPathMap,
    getMatch,
  ],
  (pathMap, { params }) => {
    const linkParts = getLinkParts(link);
    const linkQuery = linkParts.query || '';
    const isHttpLink = /^https?:$/.test(linkParts.protocol); // For example: email links are non-HTTP
    const isAbsoluteLink = isAbsolute(link);
    const { hostname } = linkParts;
    const isAbsoluteNonBabbelLink = isAbsoluteLink &&
      !isBabbelHostname(hostname) && !hostIsStaging(hostname);

    if (!isHttpLink || isAbsoluteNonBabbelLink) {
      return link;
    }

    const linkPath = linkParts.pathname;

    const editionMatch = getFirstMatch(
      editionPathTypeOrder,
      pathMap,
      linkPath,
    );

    if (!editionMatch) {
      return isAbsoluteLink ?
        link : prependEditionHostname(params.language, linkPath);
    }

    const pathLanguageCode = getLanguageCodeFromPath(linkPath);
    const newLanguageCode = HOME === editionMatch.pathType ?
      checkUsEnglish(pathLanguageCode) : getEditionFromLocale(pathLanguageCode);
    const pathTypeToPath = compile(pathMap[editionMatch.pathType]);
    const convertedPath = pathTypeToPath({
      ...editionMatch.params,
      language: newLanguageCode,
    });
    const fullLink = prependEditionHostname(newLanguageCode, convertedPath) +
      linkQuery;
    return fullLink;
  },
);

export default createGetEditionPath;
